import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StoredQuickBuild } from 'src/app/core/services/quick-build-storage.service';

@Component({
    selector: 'app-people-add-quick-build',
    templateUrl: './add-quick-build-modal.component.html',
    styleUrls: ['./add-quick-build-modal.component.scss'],
    standalone: false
})
export class AddQuickBuildModalComponent implements OnInit {
  form: FormGroup;
  name: string;
  category?: string;
  description?: string;
  editMode: boolean = false;
  quickBuild?: StoredQuickBuild;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddQuickBuildModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.editMode = data.editMode || false;
      this.quickBuild = data.quickBuild;
      if (this.quickBuild) {
        this.name = this.quickBuild.name;
        this.category = this.quickBuild.category;
        this.description = this.quickBuild.description;
      }
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [this.name, [Validators.required]],
      category: [this.category],
      description: [this.description],
    });
  }

  save() {
    if (this.form.valid) {
      this.dialogRef.close({
        name: this.form.get('name')?.value,
        category: this.form.get('category')?.value,
        description: this.form.get('description')?.value,
      });
    }
  }

  close() {
    this.dialogRef.close();
  }
}
